module.exports = __webpack_public_path__ + "img/cow2.daf32fb6.jpg";